import React from "react";

import logo from "../../Images/success.png";
import BackLink from "../Controls/BackLink";
import PageLayout from "../Controls/PageLayout";
import { useNavigate } from "react-router-dom";
import { Button, Heading, Image, VStack } from "@chakra-ui/react";

export default function End() {
  const navigate = useNavigate();
  return (
    <PageLayout>
      <BackLink page="/PreAuthentication" />
      <VStack spacing={5}>
        <Heading variant="pageHeader">The End</Heading>
        <Image id="logo" src={logo} borderRadius="lg" alt="Success." />

        <Heading fontSize="sm">
          You have successfully connected your account
        </Heading>

        <Button
          colorScheme="blue"
          id="tblButton"
          onClick={() => {
            navigate("/");
          }}
          title="View the highlighted report."
        >
          Restart The Demo
        </Button>
      </VStack>
    </PageLayout>
  );
}
